import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user/user.module';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  providers: [UserService]
})

export class LoginComponent implements OnInit {
  title: string;
  user: User;
  token;
  identity;
  status: string;
  loading: boolean = false;
  constructor(private _userService: UserService, private _route: ActivatedRoute, private _router: Router) {
    this.title = 'Inicio de Sesión';
    this.user = new User(1, '', '', '', '', '', false)
  }

  ngOnInit() {
    this.identity = this._userService.getIdentity();

    if (this.identity != null) {
      this._router.navigate(["/"]);
    }
    //console.log("login component cargado correctamente");
    let user = this._userService.getIdentity();
    //console.log(user.name);
    this.logout();
  }

  onSubmit(form) {
    this.loading = true;
    this._userService.signup(this.user).subscribe(
      response => {
        // Token
        if (response.status != 'error') {
          this.status = 'success';
          this.token = response;
          localStorage.setItem('token', this.token);

          // Objeto usuario identificado
          this._userService.signup(this.user, true).subscribe(
            response => {
              this.identity = response;
              localStorage.setItem('identity', JSON.stringify(this.identity));

              // Redirección
              this._router.navigate(['home']);
            },
            error => {
              console.log(<any>error);
              this.loading = false;
            }
          );
        } else {
          this.status = 'error';
          console.log("error");
          this.loading = false;
        }
      },
      error => {
        this.status = 'error';
        console.log(<any>error);
        this.loading = false;
        let message_error = "Mensaje: " + <any>error.message + "Nombre: " + <any>error.name + "Status: " + <any>error.status + "Texto Status: " + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            console.log('Reporte');
          },
          error => {
            console.log(<any>error);
          }
        );
      }
    );
  }

  logout() {

    this._route.params.subscribe(params => {
      let logout = +params['sure'];

      if (logout == 1) {
        localStorage.removeItem('identity');
        localStorage.removeItem('token');

        this.identity = null;
        this.token = null;

        // redirección
        //this._router.navigate(['home']);
      }
    });
  }

}
